<template>
	<A class="OptionButton" @click="onClick">
		{{ data.label }}
	</A>
</template>

<script>
	export default {
		props: ['data'],
		methods: {
			onClick() {
				this.$emit('select', this.data);
			}
		}
	};
</script>

<style scoped lang="scss">
	.OptionButton {
		padding: 1rem 2rem;
		color: var(--clrTheme);
		background-color: white;
		border-radius: 8rem;
		box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
		font-weight: bold;

		&:hover,
		&:focus,
		&:active {
			color: white;
			background-color: var(--clrTheme);
		}
	}
</style>
